import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actions from "../actions/itSalesActions";
import * as api from "../../api/itSalesApi";
import * as types from "../constants/itSalesConstants";

function* getItSalesPartnersSaga(action) {
  try {
    const response = yield call(api.getItSalesPartnersApi, action.payload);
    yield put(actions.getItSalesPartnersSuccess(response));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch IT Sales partners";
    yield put(actions.getItSalesPartnersFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* addItSalesPartnerSaga(action) {
  try {
    const response = yield call(api.addItSalesPartnerApi, action.payload);
    yield put(actions.addItSalesPartnerSuccess(response));
    toast.success("IT Sales Partner created successfully!");

    // Refresh the list
    const refreshParams = action.payload.refreshParams || {
      limit: 10,
      page: 1,
    };
    yield put(actions.getItSalesPartners(refreshParams));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to add IT Sales partner";
    yield put(actions.addItSalesPartnerFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* editItSalesPartnerSaga(action) {
  try {
    const response = yield call(api.editItSalesPartnerApi, action.payload);
    yield put(actions.editItSalesPartnerSuccess(response));
    toast.success("IT Sales Partner updated successfully!");

    // Refresh the list
    const refreshParams = action.payload.refreshParams || {
      limit: 10,
      page: 1,
    };
    yield put(actions.getItSalesPartners(refreshParams));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to update IT Sales partner";
    yield put(actions.editItSalesPartnerFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* deleteItSalesPartnerSaga(action) {
  try {
    yield call(
      api.deleteItSalesPartnerApi,
      action.payload.id || action.payload
    );
    yield put(
      actions.deleteItSalesPartnerSuccess(action.payload.id || action.payload)
    );
    toast.success("IT Sales Partner deleted successfully!");

    // Refresh the list
    const refreshParams = action.payload.refreshParams || {
      limit: 10,
      page: 1,
    };
    yield put(actions.getItSalesPartners(refreshParams));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to delete IT Sales partner";
    yield put(actions.deleteItSalesPartnerFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* changeItSalesStatusSaga(action) {
  try {
    const response = yield call(api.changeItSalesStatusApi, action.payload);
    yield put(actions.changeItSalesStatusSuccess(response));
    toast.success("Status updated successfully!");

    // Refresh the list
    const refreshParams = action.payload.refreshParams || {
      limit: 10,
      page: 1,
    };
    yield put(actions.getItSalesPartners(refreshParams));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to update status";
    yield put(actions.changeItSalesStatusFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* resetItSalesPasswordSaga(action) {
  try {
    const response = yield call(api.resetItSalesPasswordApi, action.payload);
    yield put(actions.resetItSalesPasswordSuccess(response));
    toast.success("Password reset successfully and email sent!");
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to reset password";
    yield put(actions.resetItSalesPasswordFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* getLicensesSaga(action) {
  try {
    const response = yield call(api.getLicenseslistApi);
    yield put(actions.getLicensesSuccess(response));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch licenses";
    yield put(actions.getLicensesFailure(errorMessage));
  }
}

function* getItSalesPartnerOemListSaga(action) {
  try {
    const response = yield call(
      api.getItSalesPartnerOemListApi,
      action.payload
    );
    yield put(actions.getItSalesPartnerOemListSuccess(response));
  } catch (error) {
    console.error("IT Sales Partner OEM List API Error:", error);
    let errorMessage = "Failed to fetch IT Sales partner OEM list";

    if (error.response?.status === 401) {
      errorMessage = "Unauthorized access to OEM partners data";
    } else if (error.response?.status === 403) {
      errorMessage = "Access forbidden - insufficient permissions";
    } else if (error.response?.status === 404) {
      errorMessage = "OEM partners endpoint not found";
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    }

    yield put(actions.getItSalesPartnerOemListFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* getItSalesPartnerOemUsersSaga(action) {
  yield put(actions.getItSalesPartnerOemUsersSuccess([]));

  try {
    const response = yield call(
      api.getItSalesPartnerOemUsersApi,
      action.payload
    );
    yield put(actions.getItSalesPartnerOemUsersSuccess(response));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch IT Sales partner OEM users";
    yield put(actions.getItSalesPartnerOemUsersFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* resendItSalesVerificationEmailSaga(action) {
  try {
    const response = yield call(api.resendItSalesVerificationEmailApi, action.payload);
    yield put(actions.resendItSalesVerificationEmailSuccess(response));
    toast.success('Verification email sent successfully!');
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to send verification email';
    yield put(actions.resendItSalesVerificationEmailFailure(errorMessage));
    toast.error(errorMessage);
  }
}

function* itSalesSaga() {
  yield takeEvery(types.GET_ITSALES_PARTNERS_REQUEST, getItSalesPartnersSaga);
  yield takeEvery(types.ADD_ITSALES_PARTNER_REQUEST, addItSalesPartnerSaga);
  yield takeEvery(types.EDIT_ITSALES_PARTNER_REQUEST, editItSalesPartnerSaga);
  yield takeEvery(
    types.DELETE_ITSALES_PARTNER_REQUEST,
    deleteItSalesPartnerSaga
  );
  yield takeEvery(types.CHANGE_ITSALES_STATUS_REQUEST, changeItSalesStatusSaga);
  yield takeEvery(
    types.RESET_ITSALES_PASSWORD_REQUEST,
    resetItSalesPasswordSaga
  );
  yield takeEvery(types.GET_ITSALES_LICENSES_REQUEST, getLicensesSaga);
  yield takeEvery(
    types.GET_ITSALES_PARTNER_OEM_LIST_REQUEST,
    getItSalesPartnerOemListSaga
  );
  yield takeEvery(
    types.GET_ITSALES_PARTNER_OEM_USERS_REQUEST,
    getItSalesPartnerOemUsersSaga
  );
  yield takeEvery(types.RESEND_ITSALES_VERIFICATION_EMAIL_REQUEST, resendItSalesVerificationEmailSaga);
}

export default itSalesSaga;
